var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { IdOutskirtBuildings } from "../../constants/IdOutskirtBuildings";
import { MarketConstants } from "../../constants/MarketConstants";
import { StateBuildingGraphics } from "../../graphics/StateBuildingGraphics";
import { selectContractCooldownBuffAmount } from "../../selectors/selectBuffsInfo";
import { selectContractCooldownTime, selectHasFulfillableContract, } from "../../selectors/selectContractInfo";
import { utilTime } from "../../utils/utilTime";
import { OutskirtBuilding, } from "../outskirts/OutskirtBuilding";
var OutskirtBuildingMarket = /** @class */ (function (_super) {
    __extends(OutskirtBuildingMarket, _super);
    function OutskirtBuildingMarket() {
        var _this = _super.call(this, IdOutskirtBuildings.Market) || this;
        _this.lastBuildingState = StateBuildingGraphics.Idle;
        _this.shouldUpdate = function (props, prevProps) {
            if (!props.areAssetsLoaded) {
                return false;
            }
            var needsTruckUpdate = _this.needsTruckUpdate();
            var previousLevel = _this.getLevelFromBuildingData(prevProps.data);
            var nextLevel = _this.getLevelFromBuildingData(props.data);
            var levelDiffers = previousLevel !== nextLevel;
            return (!prevProps ||
                levelDiffers ||
                needsTruckUpdate ||
                props.contractCooldownTimestamp !== prevProps.contractCooldownTimestamp ||
                prevProps.areAssetsLoaded !== props.areAssetsLoaded ||
                prevProps.isAccessible !== props.isAccessible ||
                prevProps.shouldRenderCallout !== props.shouldRenderCallout);
        };
        _this.mapState = function (state) {
            var baseState = _this.baseMapState(state);
            var contractCooldownTimestamp = selectContractCooldownTime().cooldownTime || 0;
            var contractCooldownBuff = selectContractCooldownBuffAmount(state, MarketConstants.ContractCooldownTime);
            var shouldRenderCallout = selectHasFulfillableContract(state);
            return __assign({}, baseState, { contractCooldownBuff: contractCooldownBuff,
                contractCooldownTimestamp: contractCooldownTimestamp,
                shouldRenderCallout: shouldRenderCallout });
        };
        _this.update = function (props) {
            if (_this.needsAnimationForContractCompleted()) {
                _this.lastBuildingState = StateBuildingGraphics.FinishedProduction;
            }
            else if (_this.needsAnimationForNewContract()) {
                _this.lastBuildingState = StateBuildingGraphics.RunningProduction;
            }
            else {
                _this.lastBuildingState = StateBuildingGraphics.Idle;
            }
            _this.baseUpdate(props, _this.lastBuildingState, true, props.shouldRenderCallout);
        };
        _this.needsTruckUpdate = function () {
            return _this.needsAnimationForContractCompleted() && _this.needsAnimationForNewContract();
        };
        _this.needsAnimationForContractCompleted = function () {
            var contractCompleted = _this.props.contractCooldownTimestamp <= 0;
            var needsTruckAnimation = _this.lastBuildingState === StateBuildingGraphics.RunningProduction;
            return contractCompleted && needsTruckAnimation;
        };
        _this.needsAnimationForNewContract = function () {
            var contractRunning = _this.isContractRunning(_this.props.contractCooldownTimestamp, _this.props.contractCooldownBuff);
            var needsTruckAnimation = _this.lastBuildingState !== StateBuildingGraphics.RunningProduction;
            return contractRunning && needsTruckAnimation;
        };
        _this.isContractRunning = function (contractCooldownTimestamp, contractCooldownBuff) {
            var timeLeft = utilTime.secondsLeftTill(contractCooldownTimestamp);
            var animationTime = contractCooldownBuff - OutskirtBuildingMarket.RunningProductionAnimEpsilon;
            return timeLeft > 0 && timeLeft >= animationTime;
        };
        _this.getLevelFromBuildingData = function (data) {
            return data.proto && data.proto.stage ? data.proto.stage : -1;
        };
        return _this;
    }
    OutskirtBuildingMarket.RunningProductionAnimEpsilon = 2;
    return OutskirtBuildingMarket;
}(OutskirtBuilding));
export { OutskirtBuildingMarket };



//////////////////
// WEBPACK FOOTER
// ./src/features/market/OutskirtBuildingMarket.ts
// module id = 2176
// module chunks = 3